<template>
    <div 
        @click.self="handleClickClose"
        class="popup"
    >
        <div class="__window container">
            <div class="__control">
                <button
                    @click="handleClickClose"
                ><img :src="close" alt="close"></button>
            </div>
            <div class="__content">
                <slot></slot>
            </div>
        </div>
    </div>
</template>
<script>
import close from '@/assets/x.svg'
export default {
    name: 'PopupBlock',
    components: {},
    props: {},
    emits: [ 'eventClosePopup' ],
    data() {
        return {
            close,
        }
    },
    mounted() {
    },
    methods: {
        handleClickClose: function() {
            this.$emit( 'eventClosePopup' )
            
        },
    }
}
</script>
<style lang="scss">
$bg: #290A4FCC;
$secondary: #45289C;
.popup{
    position: fixed;
    // display: flex;
    // align-items: center;
    top: 0;
    left: 0;
    // height: calc( 100vh + 20px );
    // height: 100%;
    height: 100vh;
    width: 100vw;
    z-index: 1050;

    background-color: $bg;
    // padding-top: 25px;
    // padding-bottom: 25px;
    overflow-y: scroll;
    .__window{
        position: relative;
        margin: 25px auto;
        background-color: $secondary;
        border-radius: 15px;
    }
    .__control{
        position: absolute;
        top: 15px;
        right: 15px;
        button{
            background: none;
            border: none;
            cursor: pointer;
        }
    }
    .__content{
        padding: 50px 15px 15px 15px;
    }
}
</style>